module.exports = {
  REACT_APP_ENDPOINT: process.env.REACT_APP_ENDPOINT || 'http://localhost:8000/v1',
  // REACT_APP_ENDPOINT: process.env.REACT_APP_ENDPOINT || 'https://nebulapi-asg.hostplatform.com/v1',
  // REACT_APP_ENDPOINT: process.env.REACT_APP_ENDPOINT || 'http://172.16.50.244:8000/v1',
  // REACT_APP_ENDPOINT: process.env.REACT_APP_ENDPOINT || 'https://nebulapi-alpha.hostplatform.com/v1',
  // REACT_APP_ENDPOINT: process.env.REACT_APP_ENDPOINT || 'http://192.168.0.69:8000/v1',
  // REACT_APP_ENDPOINT: process.env.REACT_APP_ENDPOINT || 'http://192.168.0.23:8000/v1',
  // REACT_APP_ENDPOINT: process.env.REACT_APP_ENDPOINT || 'http://172.16.50.58:8000/v1',
  // REACT_APP_ENDPOINT: process.env.REACT_APP_ENDPOINT || 'http://172.16.50.81:8005/v1',
  // REACT_APP_ENDPOINT: process.env.REACT_APP_ENDPOINT || 'http://localhost:8000/v1',
  // REACT_APP_ENDPOINT: process.env.REACT_APP_ENDPOINT || 'http://localhost:8000/v1',
  REACT_APP_BOOKING_ENGINE_URL: process.env.REACT_APP_BOOKING_ENGINE_URL || 'http://localhost:3002',
  REACT_APP_HOTEL_BOOKING_ENGINE_URL: process.env.REACT_APP_HOTEL_BOOKING_ENGINE_URL || 'http://localhost:3002',
  REACT_APP_IS_SHOW_TRAVELOKA: process.env.REACT_APP_IS_SHOW_TRAVELOKA || true,
  REACT_APP_IS_SHOW_TIKETCOM: process.env.REACT_APP_IS_SHOW_TIKETCOM || true,
  REACT_APP_IS_SHOW_INVENTORY: process.env.REACT_APP_IS_SHOW_INVENTORY,
  REACT_APP_IS_SHOW_PROMOTION: process.env.REACT_APP_IS_SHOW_PROMOTION,
  REACT_APP_IS_SHOW_ADDON: process.env.REACT_APP_IS_SHOW_ADDON,

  REACT_APP_IS_SHOW_BCOM_PUSH_CONTENT: process.env.REACT_APP_IS_SHOW_BCOM_PUSH_CONTENT,
  REACT_APP_IS_SHOW_BCOM_PRICING_SETTINGS: process.env.REACT_APP_IS_SHOW_BCOM_PRICING_SETTINGS,

  REACT_APP_GOOGLE_MAP_KEY: process.env.REACT_APP_GOOGLE_MAP_KEY,

  REACT_APP_UNIFIED_INBOX_ENDPOINT: process.env.REACT_APP_UNIFIED_INBOX_ENDPOINT || 'http://localhost:3000',
  REACT_APP_SENRSOFT_URL: process.env.REACT_APP_SENRSOFT_URL || 'https://einvoice-api-stg.sernsoft.com/api', //'https://einvoice-api.sernsoft.com/api', //'http://localhost:8006/api', //
  REACT_APP_E_INVOICE_URL: process.env.REACT_APP_E_INVOICE_URL || 'https://einvoice-stg.sernsoft.com/', // 'https://einvoice-hp.sernsoft.com' // 'http://localhost:3000' //  //

  WEBSOCKET_ENDPOINT: process.env.REACT_APP_WEBSOCKET_ENDPOINT || 'http://localhost:8000'
};
